import styled from 'styled-components';

// ---------------------------------------------------------------------------
// Régua de Cobrança — cabeçalho sobre o shell escuro: cartões de valor (KPI) e
// botão de shell. O fundo gradiente é do próprio AppShell (Shell.js) — a página
// não pinta fundo nenhum.
// ---------------------------------------------------------------------------

// A tela é mais larga que o Container padrão (kanban com 6 colunas de 302px):
// wrapper fluido com o mesmo padding do protótipo, sem max-width.
export const PageWrap = styled.div`
   width: 100%;
   padding: 16px;
   display: flex;
   flex-direction: column;
   gap: 14px;

   @media (min-width: 768px) {
      padding: 22px 24px 40px;
   }
`;

export const HeaderRow = styled.div`
   display: flex;
   align-items: flex-start;
   justify-content: space-between;
   gap: 20px;
   flex-wrap: wrap;
`;

export const HeaderActions = styled.div`
   display: flex;
   gap: 10px;
   align-items: center;
   flex-wrap: wrap;
`;

export const KpiTile = styled.div`
   min-width: 132px;
   height: 56px;
   padding: 0 16px;
   border-radius: 12px;
   border: 1px solid rgba(255, 255, 255, 0.14);
   background: rgba(0, 0, 0, 0.18);
   display: flex;
   flex-direction: column;
   justify-content: center;
   gap: 2px;
`;

export const KpiLabel = styled.span`
   font-size: 10px;
   font-weight: 800;
   letter-spacing: 0.08em;
   text-transform: uppercase;
   color: #a9a9a9;
   white-space: nowrap;
`;

export const KpiValue = styled.b`
   font-size: 19px;
   font-weight: 800;
   font-variant-numeric: tabular-nums;
   white-space: nowrap;
   color: ${({ $alert }) => ($alert ? '#ffb4b4' : '#fff')};
`;

// Botão sobre o shell escuro (mesmo caso local do 0084 — FC7 §G.2 mantém os
// controles de shell escuro fora do kit claro).
export const ShellButton = styled.button`
   display: inline-flex;
   align-items: center;
   gap: 8px;
   height: 40px;
   padding: 0 16px;
   border-radius: 10px;
   border: 1px solid rgba(255, 255, 255, 0.16);
   background: transparent;
   color: ${({ theme }) => theme?.colors?.textOnAppBackground ?? '#e5e5e5'};
   font-size: 14px;
   font-weight: 600;
   white-space: nowrap;
   cursor: pointer;
   transition: background 140ms ease, border-color 140ms ease;

   &:hover:not(:disabled) {
      background: rgba(255, 255, 255, 0.08);
   }

   &:disabled {
      opacity: 0.55;
      cursor: not-allowed;
   }

   &:focus-visible {
      outline: none;
      box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.24);
   }

   svg {
      flex-shrink: 0;
   }
`;
